import {useQuery} from "@tanstack/react-query";

import type {ParamsOptions} from "@/src/modules/core/types";

import {companyVehiclesService} from "../services";

export function useCompanyVehicles(
  options?: ParamsOptions,
  {enabled = true}: {enabled?: boolean} = {},
) {
  const can = companyVehiclesService.getCanListCompanyVehicles();
  const query = useQuery({
    queryKey: ["company-vehicles", options],
    queryFn: () => companyVehiclesService.getCompanyVehicles(options),
    enabled: can && enabled,
  });

  return {
    ...query,
    vehicles: query.data?.data ?? [],
    total: query.data?.meta?.total ?? 0,
  };
}
